import {
    IChatOverviewConfig,
    IChatOverviewBillboardConfig,
    ICardHeaderConfig,
    IMultiLevelDualAxisLineGraphConfig,
    IDefaultTableColumnConfig } from '../../../../_shared/models/models-index';
import { Enums } from '../../../../_shared/enums/enums';
import * as constants from '../../../../_shared/constants/constants';

export class ChatOverviewConfig implements IChatOverviewConfig {
    public reportTitle = 'Chat Overview';
    public hasChatHelpText: false;
    public metricDisplayModes = [
        { name: 'MOM', value: 'MOM' },
        { name: 'YOY', value: 'YOY' }
    ];
    public billboards: IChatOverviewBillboardConfig[] = [
        {
            title: 'Visits with Chat Impressions',
            subtitle: '',
            iconClass: 'fa-user fa-primary',
            reverseMetric: false,
            metricCurrentPropertyName: 'visitsWithImpressions',
            metricMOMPropertyName: 'visitsWithImpressionsMOM',
            metricYOYPropertyName: 'visitsWithImpressionsYOY',
            metricPreviousMonthPropertyName: null,
            metricPreviousMTDPropertyName: null,
            metricPreviousMTDDisplayOnCurrentMonth: false,
            metricPreviousMTDDisplayHistorical: false,
            metricPreviousMTDLabel: '',
            metricPreviousMonthDisplayOnCurrentMonth: false,
            metricPreviousMonthDisplayHistorical: false,
            metricPreviousMonthLabel: '',
            metricPreviousYearPropertyName: null,
            footerRowCount: 1,
            footerTwoLeftLabel: 'MOM',
            footerTwoRightLabel: 'YOY',
            footerTwoMetricFormatKey: constants.formatKeys.percentageTwoDecimals,
            showTrendArrow: false,
            trendArrowDrivingPropertyName: 'visitsWithImpressionsMOM',
            metricFormatKey: constants.formatKeys.abbreviatedLocaleString,
            helpTextKey: 'ChatOverviewVisitsWithChatImpressionsHelp',
            helpTextTitle: 'Visits with Chat Impressions'
        },
        {
            title: 'Chats Started',
            subtitle: '',
            iconClass: 'fa-comments fa-primary',
            reverseMetric: false,
            metricCurrentPropertyName: 'starts',
            metricMOMPropertyName: 'startsMOM',
            metricYOYPropertyName: 'startsYOY',
            metricPreviousMonthPropertyName: null,
            metricPreviousMTDPropertyName: null,
            metricPreviousMTDDisplayOnCurrentMonth: false,
            metricPreviousMTDDisplayHistorical: false,
            metricPreviousMTDLabel: '',
            metricPreviousMonthDisplayOnCurrentMonth: false,
            metricPreviousMonthDisplayHistorical: false,
            metricPreviousMonthLabel: '',
            metricPreviousYearPropertyName: null,
            footerRowCount: 1,
            footerTwoLeftLabel: 'MOM',
            footerTwoRightLabel: 'YOY',
            footerTwoMetricFormatKey: constants.formatKeys.percentageTwoDecimals,
            showTrendArrow: false,
            trendArrowDrivingPropertyName: 'startsMOM',
            metricFormatKey: constants.formatKeys.abbreviatedLocaleString,
            helpTextKey: 'ChatOverviewChatsStartedHelp',
            helpTextTitle: 'Chats Started'
        },
        {
            title: 'Chat Start Rate',
            subtitle: '',
            iconClass: 'fa-percent fa-primary',
            reverseMetric: false,
            metricCurrentPropertyName: 'startRate',
            metricMOMPropertyName: 'startRateMOM',
            metricYOYPropertyName: 'startRateYOY',
            metricPreviousMonthPropertyName: null,
            metricPreviousMTDPropertyName: null,
            metricPreviousMTDDisplayOnCurrentMonth: false,
            metricPreviousMTDDisplayHistorical: false,
            metricPreviousMTDLabel: '',
            metricPreviousMonthDisplayOnCurrentMonth: false,
            metricPreviousMonthDisplayHistorical: false,
            metricPreviousMonthLabel: '',
            metricPreviousYearPropertyName: null,
            footerRowCount: 1,
            footerTwoLeftLabel: 'MOM',
            footerTwoRightLabel: 'YOY',
            footerTwoMetricFormatKey: constants.formatKeys.percentageTwoDecimals,
            showTrendArrow: false,
            trendArrowDrivingPropertyName: 'startRateMOM',
            metricFormatKey: constants.formatKeys.percentageOneDecimal,
            helpTextKey: 'ChatOverviewChatStartRateHelp',
            helpTextTitle: 'Chat Start Rate'
        },
        {
            title: 'Chat Engagement Rate',
            subtitle: '',
            iconClass: 'fa-percent fa-primary',
            reverseMetric: false,
            metricCurrentPropertyName: 'engagementRate',
            metricMOMPropertyName: 'engagementRateMOM',
            metricYOYPropertyName: 'engagementRateYOY',
            metricPreviousMonthPropertyName: null,
            metricPreviousMTDPropertyName: null,
            metricPreviousMTDDisplayOnCurrentMonth: false,
            metricPreviousMTDDisplayHistorical: false,
            metricPreviousMTDLabel: '',
            metricPreviousMonthDisplayOnCurrentMonth: false,
            metricPreviousMonthDisplayHistorical: false,
            metricPreviousMonthLabel: '',
            metricPreviousYearPropertyName: null,
            footerRowCount: 1,
            footerTwoLeftLabel: 'MOM',
            footerTwoRightLabel: 'YOY',
            footerTwoMetricFormatKey: constants.formatKeys.percentageTwoDecimals,
            showTrendArrow: false,
            trendArrowDrivingPropertyName: 'engagementRateMOM',
            metricFormatKey: constants.formatKeys.percentageOneDecimal,
            helpTextKey: 'ChatOverviewChatEngagementRateHelp',
            helpTextTitle: 'Chat Engagement Rate'
        },
    ];

    public kpiSheetOptions = {
        overview: [{
            name: 'providerId',
            label: 'Provider',
            isHeader: true
        }, {
            name: 'visitsWithImpressions',
            label: 'Visits With Chat Impressions',
            format: constants.formatKeys.abbreviatedLocaleString
        }, {
            name: 'starts',
            label: 'Chats Started',
            format: constants.formatKeys.localeString
        }, {
            name: 'startRate',
            label: 'Chat Start Rate',
            format: constants.formatKeys.percentageTwoDecimals
        }, {
            name: 'engagementRate',
            label: 'Chat Engagement Rate',
            format: constants.formatKeys.percentageTwoDecimals
        }, {
            name: 'abandonRate',
            label: 'Chat Abandoned Rate',
            format: constants.formatKeys.percentageTwoDecimals
        }, {
            name: 'messagesPerChat',
            label: 'Average Messages/Chat',
            format: constants.formatKeys.roundToTenth
        }]
      };

    public benchmarkCardHeader: ICardHeaderConfig = {
        title: 'Summary Data',
        iconClass: 'fa-file',
        helpTextKey: constants.helpTextKeys.chatSummaryHelp,
        helpTextTitle: 'Chat Summary',
        exportName: 'Chat Summary - Summary Data',
        metricDisplayModes: ['MOM', 'YOY']
    };

    public trendGraphConfig: IMultiLevelDualAxisLineGraphConfig = {
        xAxisPropertyName: 'date',
        parentMetrics: [
            {
                id: Enums.chatMetrics.visitsWithImpressions.metricId,
                displayName: Enums.chatMetrics.visitsWithImpressions.name,
                propertyName: Enums.chatMetrics.visitsWithImpressions.nameKey,
                metricFormatKey: constants.formatKeys.localeString
            },
            {
                id: Enums.chatMetrics.impressions.metricId,
                displayName: Enums.chatMetrics.impressions.name,
                propertyName: Enums.chatMetrics.impressions.nameKey,
                metricFormatKey: constants.formatKeys.localeString
            },
            {
                id: Enums.chatMetrics.chatsStarted.metricId,
                displayName: Enums.chatMetrics.chatsStarted.name,
                propertyName: Enums.chatMetrics.chatsStarted.nameKey,
                metricFormatKey: constants.formatKeys.localeString
            },
            {
                id: Enums.chatMetrics.chatStartRate.metricId,
                displayName: 'Chat Start Rate',
                propertyName: Enums.chatMetrics.chatStartRate.nameKey,
                metricFormatKey: constants.formatKeys.percentageTwoDecimals
            },
            {
                id: Enums.chatMetrics.chatsAbandoned.metricId,
                displayName: Enums.chatMetrics.chatsAbandoned.name,
                propertyName: Enums.chatMetrics.chatsAbandoned.nameKey,
                metricFormatKey: constants.formatKeys.localeString
            },
            {
                id: Enums.chatMetrics.chatAbandonRate.metricId,
                displayName: Enums.chatMetrics.chatAbandonRate.name,
                propertyName: Enums.chatMetrics.chatAbandonRate.nameKey,
                metricFormatKey: constants.formatKeys.percentageTwoDecimals
            },
            {
                id: Enums.chatMetrics.chatsEngaged.metricId,
                displayName: Enums.chatMetrics.chatsEngaged.name,
                propertyName: Enums.chatMetrics.chatsEngaged.nameKey,
                metricFormatKey: constants.formatKeys.localeString
            },
            {
                id: Enums.chatMetrics.chatEngagementRate.metricId,
                displayName: Enums.chatMetrics.chatEngagementRate.name,
                propertyName: Enums.chatMetrics.chatEngagementRate.nameKey,
                metricFormatKey: constants.formatKeys.percentageTwoDecimals
            },
            {
                id: Enums.chatMetrics.avgMessagesPerChat.metricId,
                displayName: Enums.chatMetrics.avgMessagesPerChat.name,
                propertyName: Enums.chatMetrics.avgMessagesPerChat.nameKey,
                metricFormatKey: constants.formatKeys.roundToHundreth
            },
        ],
        childMetrics: [
            {
                id: Enums.chatProviders.allProviders.providerId,
                displayName: Enums.chatProviders.allProviders.displayName,
                propertyName: Enums.chatProviders.allProviders.name,
                metricFormatKey: constants.formatKeys.entityDisplayName
            },
            {
                id: Enums.chatProviders.activEngage.providerId,
                displayName: Enums.chatProviders.activEngage.displayName,
                propertyName: Enums.chatProviders.activEngage.name,
                metricFormatKey: constants.formatKeys.entityDisplayName
            },
            {
                id: Enums.chatProviders.carNow.providerId,
                displayName: Enums.chatProviders.carNow.displayName,
                propertyName: Enums.chatProviders.carNow.name,
                metricFormatKey: constants.formatKeys.entityDisplayName
            },
            {
                id: Enums.chatProviders.conversations.providerId,
                displayName: Enums.chatProviders.conversations.displayName,
                propertyName: Enums.chatProviders.conversations.name,
                metricFormatKey: constants.formatKeys.entityDisplayName
            },
            {
                id: Enums.chatProviders.gubagoo.providerId,
                displayName: Enums.chatProviders.gubagoo.displayName,
                propertyName: Enums.chatProviders.gubagoo.name,
                metricFormatKey: constants.formatKeys.entityDisplayName
            },
            {
                id: Enums.chatProviders.podium.providerId,
                displayName: Enums.chatProviders.podium.displayName,
                propertyName: Enums.chatProviders.podium.name,
                metricFormatKey: constants.formatKeys.entityDisplayName
            },
        ],
        defaultChildrenIds: [ Enums.chatProviders.allProviders.providerId, Enums.chatProviders.allProviders.providerId ],
        defaultParentIds: [ Enums.chatMetrics.impressions.metricId, Enums.chatMetrics.chatsStarted.metricId ],
        metricOneColorHexCode: '#34383c',
        metricTwoColorHexCode: '#c51230'
    };
    public summaryTableColumns: IDefaultTableColumnConfig[] = [
        {
            show: true,
            header: '',
            columnDef: 'entity',
            isMom: false,
            isYoy: false,
            metricFormatKey: constants.formatKeys.entityDisplayName,
            clickable: true
        },
        {
            show: false,
            print: true,
            header: 'Dealer Name',
            columnDef: 'displayName',
            isMom: false,
            isYoy: false,
            metricFormatKey: constants.formatKeys.entityDisplayName,
        },
        {
            show: true,
            header: 'Chat Impressions',
            columnDef: 'impressions', isMom: false, isYoy: false, metricFormatKey: constants.formatKeys.localeString, clickable: false },
        {
            show: false,
            header: 'Prev. Month Chat Impressions',
            columnDef: 'impressionsPreviousMTD', isMom: true, isYoy: false, metricFormatKey: constants.formatKeys.localeString, clickable: false },
        {
            show: false,
            header: 'Chat Impressions MOM',
            columnDef: 'impressionsMOM', isMom: true, isYoy: false, metricFormatKey: constants.formatKeys.percentageTwoDecimals, clickable: false },
        {
            show: false,
            header: 'Prev. Year Chat Impressions',
            columnDef: 'impressionsPreviousYear', isMom: false, isYoy: true, metricFormatKey: constants.formatKeys.localeString, clickable: false },
        {
            show: false,
            header: 'Chat Impressions YOY',
            columnDef: 'impressionsYOY', isMom: false, isYoy: true, metricFormatKey: constants.formatKeys.percentageTwoDecimals, clickable: false },

        {
            show: true,
            header: 'Visits with Chat Impressions',
            columnDef: 'visitsWithImpressions', isMom: false, isYoy: false, metricFormatKey: constants.formatKeys.localeString, clickable: false },
        {
            show: false,
            header: 'Prev. Month Visits with Chat Impressions',
            columnDef: 'visitsWithImpressionsPreviousMTD', isMom: true, isYoy: false, metricFormatKey: constants.formatKeys.localeString, clickable: false },
        {
            show: false,
            header: 'Visits with Chat Impressions MOM',
            columnDef: 'visitsWithImpressionsMOM', isMom: true, isYoy: false, metricFormatKey: constants.formatKeys.percentageTwoDecimals, clickable: false },
        {
            show: false,
            header: 'Prev. Year Visits with Chat Impressions',
            columnDef: 'visitsWithImpressionsPreviousYear', isMom: false, isYoy: true, metricFormatKey: constants.formatKeys.localeString, clickable: false },
        {
            show: false,
            header: 'Visits with Chat Impressions YOY',
            columnDef: 'visitsWithImpressionsYOY', isMom: false, isYoy: true, metricFormatKey: constants.formatKeys.percentageTwoDecimals, clickable: false },

        {
            show: true,
            header: 'Chats Started',
            columnDef: 'starts', isMom: false, isYoy: false, metricFormatKey: constants.formatKeys.localeString, clickable: false },
        {
            show: false,
            header: 'Prev. Month Chats Started',
            columnDef: 'startsPreviousMTD', isMom: true, isYoy: false, metricFormatKey: constants.formatKeys.localeString, clickable: false },
        {
            show: false,
            header: 'Chats Started MOM',
            columnDef: 'startsMOM', isMom: true, isYoy: false, metricFormatKey: constants.formatKeys.percentageTwoDecimals, clickable: false },
        {
            show: false,
            header: 'Prev. Year Chats Started',
            columnDef: 'startsPreviousYear', isMom: false, isYoy: true, metricFormatKey: constants.formatKeys.localeString, clickable: false },
        {
            show: false,
            header: 'Chats Started YOY',
            columnDef: 'startsYOY', isMom: false, isYoy: true, metricFormatKey: constants.formatKeys.percentageTwoDecimals, clickable: false },

        {
            show: true,
            header: 'Chat Start Rate',
            columnDef: 'startRate', isMom: false, isYoy: false, metricFormatKey: constants.formatKeys.percentageTwoDecimals, clickable: false },
        {
            show: false,
            header: 'Prev. Month Chat Start Rate',
            columnDef: 'startRatePreviousMTD', isMom: true, isYoy: false, metricFormatKey: constants.formatKeys.percentageTwoDecimals, clickable: false },
        {
            show: false,
            header: 'Chat Start Rate MOM',
            columnDef: 'startRateMOM', isMom: true, isYoy: false, metricFormatKey: constants.formatKeys.percentageTwoDecimals, clickable: false },
        {
            show: false,
            header: 'Prev. Year Chat Start Rate',
            columnDef: 'startRatePreviousYear', isMom: false, isYoy: true, metricFormatKey: constants.formatKeys.percentageTwoDecimals, clickable: false },
        {
            show: false,
            header: 'Chat Start Rate YOY',
            columnDef: 'startRateYOY', isMom: false, isYoy: true, metricFormatKey: constants.formatKeys.percentageTwoDecimals, clickable: false },

        {
            show: true,
            header: 'Engaged Chats',
            columnDef: 'engagements', isMom: false, isYoy: false, metricFormatKey: constants.formatKeys.localeString, clickable: false },
        {
            show: false,
            header: 'Prev. Month Engaged Chats',
            columnDef: 'engagementsPreviousMTD', isMom: true, isYoy: false, metricFormatKey: constants.formatKeys.localeString, clickable: false },
        {
            show: false,
            header: 'Engaged Chats MOM',
            columnDef: 'engagementsMOM', isMom: true, isYoy: false, metricFormatKey: constants.formatKeys.percentageTwoDecimals, clickable: false },
        {
            show: false,
            header: 'Prev. Year Engaged Chats',
            columnDef: 'engagementsPreviousYear', isMom: false, isYoy: true, metricFormatKey: constants.formatKeys.localeString, clickable: false },
        {
            show: false,
            header: 'Engaged Chats YOY',
            columnDef: 'engagementsYOY', isMom: false, isYoy: true, metricFormatKey: constants.formatKeys.percentageTwoDecimals, clickable: false },

        {
            show: true,
            header: 'Chat Engagement Rate',
            columnDef: 'engagementRate', isMom: false, isYoy: false, metricFormatKey: constants.formatKeys.percentageTwoDecimals, clickable: false },
        {
            show: false,
            header: 'Prev. Month Chat Engagement Rate',
            columnDef: 'engagementRatePreviousMTD', isMom: true, isYoy: false, metricFormatKey: constants.formatKeys.percentageTwoDecimals, clickable: false },
        {
            show: false,
            header: 'Chat Engagement Rate MOM',
            columnDef: 'engagementRateMOM', isMom: true, isYoy: false, metricFormatKey: constants.formatKeys.percentageTwoDecimals, clickable: false },
        {
            show: false,
            header: 'Prev. Year Chat Engagement Rate',
            columnDef: 'engagementRatePreviousYear', isMom: false, isYoy: true, metricFormatKey: constants.formatKeys.percentageTwoDecimals, clickable: false },
        {
            show: false,
            header: 'Chat Engagement Rate YOY',
            columnDef: 'engagementRateYOY', isMom: false, isYoy: true, metricFormatKey: constants.formatKeys.percentageTwoDecimals, clickable: false
        },
        {
            show: true,
            header: 'Abandoned Chats',
            columnDef: 'abandons', isMom: false, isYoy: false, metricFormatKey: constants.formatKeys.localeString, clickable: false },
        {
            show: false,
            header: 'Prev. Month Abandoned Chats',
            columnDef: 'abandonsPreviousMTD', isMom: true, isYoy: false, metricFormatKey: constants.formatKeys.localeString, clickable: false },
        {
            show: false,
            header: 'Abandoned Chats MOM',
            columnDef: 'abandonsMOM', isMom: true, isYoy: false, metricFormatKey: constants.formatKeys.percentageTwoDecimals, clickable: false },
        {
            show: false,
            header: 'Prev. Year Abandoned Chats',
            columnDef: 'abandonsPreviousYear', isMom: false, isYoy: true, metricFormatKey: constants.formatKeys.localeString, clickable: false },
        {
            show: false,
            header: 'Abandoned Chats YOY',
            columnDef: 'abandonsYOY', isMom: false, isYoy: true, metricFormatKey: constants.formatKeys.percentageTwoDecimals, clickable: false },
        {
            show: true,
            header: 'Chat Abandon Rate',
            columnDef: 'abandonRate', isMom: false, isYoy: false, metricFormatKey: constants.formatKeys.percentageTwoDecimals, clickable: false },
        {
            show: false,
            header: 'Prev. Month Chat Abandon Rate',
            columnDef: 'abandonRatePreviousMTD', isMom: true, isYoy: false, metricFormatKey: constants.formatKeys.percentageTwoDecimals, clickable: false },
        {
            show: false,
            header: 'Chat Abandon Rate MOM',
            columnDef: 'abandonRateMOM', isMom: true, isYoy: false, metricFormatKey: constants.formatKeys.percentageTwoDecimals, clickable: false },
        {
            show: false,
            header: 'Prev. Year Chat Abandon Rate',
            columnDef: 'abandonRatePreviousYear', isMom: false, isYoy: true, metricFormatKey: constants.formatKeys.percentageTwoDecimals, clickable: false },
        {
            show: false,
            header: 'Chat Abandon Rate YOY',
            columnDef: 'abandonRateYOY', isMom: false, isYoy: true, metricFormatKey: constants.formatKeys.percentageTwoDecimals, clickable: false },
        {
            show: true,
            header: 'Avg. Messages Per Chat',
            columnDef: 'messagesPerChat', isMom: false, isYoy: false, metricFormatKey: constants.formatKeys.roundToTenth, clickable: false },
        {
            show: false,
            header: 'Prev. Month Avg. Messages Per Chat',
            columnDef: 'messagesPerChatPreviousMTD', isMom: true, isYoy: false, metricFormatKey: constants.formatKeys.roundToTenth, clickable: false },
        {
            show: false,
            header: 'Avg. Messages Per Chat MOM',
            columnDef: 'messagesPerChatMOM', isMom: true, isYoy: false, metricFormatKey: constants.formatKeys.localeString, clickable: false },
        {
            show: false,
            header: 'Prev. Year Avg. Messages Per Chat',
            columnDef: 'messagesPerChatPreviousYear', isMom: false, isYoy: true, metricFormatKey: constants.formatKeys.roundToTenth, clickable: false },
        {
            show: false,
            header: 'Avg. Messages Per Chat YOY',
            columnDef: 'messagesPerChatYOY', isMom: false, isYoy: true, metricFormatKey: constants.formatKeys.localeString, clickable: false },
    ];
}
